// Vykreslí formulářová pole podle attribute_schema typu položky.
// schema: [{key,label,type,unit,required,options}], values: {}, onChange(values)
export default function DynamicAttributeForm({ schema = [], values = {}, onChange }) {
  if (!schema || schema.length === 0) return null;

  const set = (key, val) => onChange({ ...values, [key]: val });

  return (
    <div style={{ borderTop: '1px solid var(--border)', paddingTop: 12, marginTop: 4 }}>
      <p className="text-muted" style={{ fontSize: '0.8rem', marginBottom: 8 }}>Parametry položky</p>
      {schema.map((f) => (
        <div className="form-group" key={f.key}>
          <label>
            {f.label}{f.unit ? ` (${f.unit})` : ''}{f.required ? ' *' : ''}
          </label>
          {f.type === 'select' ? (
            <select className="form-input" value={values[f.key] ?? ''} onChange={(e) => set(f.key, e.target.value)}>
              <option value="">—</option>
              {(f.options || []).map((o) => <option key={o} value={o}>{o}</option>)}
            </select>
          ) : f.type === 'boolean' ? (
            <label style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <input type="checkbox" checked={!!values[f.key]} onChange={(e) => set(f.key, e.target.checked)} />
              <span className="text-muted" style={{ fontSize: '0.85rem' }}>ano / ne</span>
            </label>
          ) : (
            <input
              className="form-input"
              type={f.type === 'number' ? 'number' : f.type === 'date' ? 'date' : 'text'}
              value={values[f.key] ?? ''}
              onChange={(e) => set(f.key, f.type === 'number' ? (e.target.value === '' ? '' : Number(e.target.value)) : e.target.value)}
            />
          )}
        </div>
      ))}
    </div>
  );
}
